import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-forgot-password-view',
  templateUrl: './forgot-password-view.component.html',
  styleUrls: ['./forgot-password-view.component.scss']
})
export class ForgotPasswordViewComponent implements OnInit {
  brand = getBrand();
  error = '';
  success = '';
  loading: boolean = false;
  returnUrl: string = '/login';
  public form: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private _sharedService: SharedService,
    private notifyService: NotifyService) {
    this.formInit();
  }

  ngOnInit() {
  }

  private formInit() {
    this.form = this.formBuilder.group({
      username: ['', [Validators.required]],
    });
  }

  forgotPassword(): void {
    this.loading = true;
    this._sharedService.loaderHide.emit(true);
    this.authenticationService.forgotPassword(this.form.controls.username.value).subscribe(
      data => {
        this.error = '';
        this.success = "Password Reset link has been sent to: " + data.message;
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('success', 'Success', this.success);
      },
      error => {
        this.error = error == 'Invalid Username' ? 'Incorrect Username. Please provide valid username' : error;
        this.success = '';
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', this.error);
      }
    );
  }

  cancel(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

}
